<div class="user-avatar" [style]="avatarStyle()">
  <img
    [class.active]="active()"
    [class.away]="user().data.status === 'away'"
    [src]="avatarUrl()"
    crossorigin="anonymous" />
  @if (showStatus()) {
    @if (user().data.hasRaisedHand) {
      <div class="status-badge" [class.away]="user().data.status === 'away'">
        <div class="status-badge__icon">
          <fa-icon class="status-badge__hand" [icon]="faHandWave"></fa-icon>
        </div>
      </div>
    } @else if (muteState()) {
      <div class="status-badge" [class.away]="user().data.status === 'away'">
        <div class="status-badge__icon">
          <andor-mute-status [user]="user()"></andor-mute-status>
        </div>
      </div>
    } @else {
      <div class="status-badge status-badge--dot" [class.away]="user().data.status === 'away'"></div>
    }
  }
</div>
